"use client";

import type { ReactNode } from "react";
import { cn } from "@/lib/utils";

type BackendDetailLayoutPropsT = {
  children: ReactNode;
  className?: string;
};

export function BackendDetailLayout({
  children,
  className = "",
}: BackendDetailLayoutPropsT) {
  return (
    <div
      className={cn(
        "grid min-h-full grid-cols-1 gap-6 pb-10 lg:grid-cols-[minmax(0,2fr)_minmax(320px,0.9fr)]",
        className
      )}
    >
      {children}
    </div>
  );
}

type BackendDetailColumnPropsT = {
  children: ReactNode;
  className?: string;
};

export function BackendDetailLeftColumn({
  children,
  className = "",
}: BackendDetailColumnPropsT) {
  return <div className={`h-full space-y-6 pt-3 ${className}`}>{children}</div>;
}

export function BackendDetailRightColumn({
  children,
  className = "",
}: BackendDetailColumnPropsT) {
  return <div className={`pt-0 lg:pt-3 ${className}`}>{children}</div>;
}
